import { requestFunnel } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';

export class BffUsersClient {
  async fullNameById(userId) {
    try {
      const options = { headers: authenticationService.authHeader() };
      const response = await requestFunnel.get(`bff/users/${userId}`, options);

      const infoUser = response.data;
      return {
        name: infoUser.name,
        lastName: infoUser.lastName,
        fullName: `${infoUser.name} ${infoUser.lastName}`.trim()
      };
    } catch (error) {
      return {
        name: '',
        lastName: '',
        fullName: 'No disponible'
      };
    }
  }
}
